import { AxiosResponse } from 'axios';
import { contentDispositionExtraction } from './contentDispositionExtraction';

//Handles download for Axios response
export const handleBlobDownload = (
  response: AxiosResponse<BlobPart>,
  name?: string
) => {
  const blob = new Blob([response.data]);
  downloadBlob(blob, name ?? contentDispositionExtraction(response));
};

//General Blob download
export const downloadBlob = (blob: Blob, name: string) => {
  const fileName = name;
  const fileUrl = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = fileUrl;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(fileUrl);
};
